import * as React from 'react';
const SvgColor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.983 5.211c2.465-3.283 7.57-4.238 11.204-1.978 3.588 2.23 4.908 6.52 3.438 10.544-1.387 3.8-5.044 5.306-7.68 3.395-.986-.716-1.37-1.614-1.554-3.072l-.088-.828-.039-.334c-.102-.783-.26-1.134-.59-1.317-.45-.25-.748-.257-1.338-.028l-.294.122-.15.065c-.85.37-1.415.5-2.13.35l-.168-.04-.137-.04c-2.339-.724-2.685-3.895-.474-6.839m.825 5.631.103.03.112.027c.368.073.683.012 1.205-.203l.505-.216c1.008-.413 1.664-.453 2.553.042.77.429 1.07 1.088 1.222 2.23l.045.385.045.446.04.354c.144 1.141.406 1.753 1.046 2.217 1.908 1.383 4.64.258 5.76-2.808 1.271-3.481.146-7.139-2.921-9.045-3.08-1.916-7.46-1.096-9.535 1.666-1.74 2.316-1.526 4.426-.18 4.875m9.41-1.672a1.048 1.048 0 1 1 2.025-.542 1.048 1.048 0 0 1-2.024.542m.415 2.925a1.048 1.048 0 1 1 2.025-.542 1.048 1.048 0 0 1-2.025.542M11.56 6.653a1.048 1.048 0 1 1 2.024-.543 1.048 1.048 0 0 1-2.024.543m-.024 7.544a1.048 1.048 0 1 1 2.024-.542 1.048 1.048 0 0 1-2.024.542M8.604 5.838a1.048 1.048 0 1 1 2.025-.542 1.048 1.048 0 0 1-2.025.542"
    />
  </svg>
);
export default SvgColor;
